import { useEffect, useState } from 'react'
import { ReactComponent as PageIcon } from 'assets/images/icons/page.svg'
import { ReactComponent as DraftPageIcon } from 'assets/images/icons/draft_page.svg'
import { ReactComponent as ResponseIcon } from 'assets/images/icons/response2.svg'
import { generateSlug, getTitle } from 'utils/helpers'
import { history } from 'store/store'
import UpgradeButton from 'modules/app/components/UpgradeButton'
import { ShortcutBadge } from 'modules/mainmenu/responses/styles'
import { direction } from 'direction'

function SearchItem(props) {
  const { content, searchText } = props
  const [_content, set_content] = useState('')
  const [_title, set_title] = useState('')

  useEffect(() => {
    let plainData = content.plain_content || ''
    let tmp_title = getTitle(content.title)
    const words = searchText.replaceAll(' ', '|').split('|')
    words.forEach((word) => {
      if (word && word.length > 1) {
        const wordRegex = new RegExp(word, 'gi')
        if (wordRegex.test(tmp_title.replace(/<[^>]*>/g, ''))) {
          const wordWithCase = tmp_title.match(wordRegex)
          tmp_title = tmp_title.replace(wordRegex, `<span class="font-weight-700">${wordWithCase[0]}</span>`)
        }
      }
    })
    set_title(tmp_title)

    const searchText_lower = words[0].toLowerCase()
    const plainData_lower = plainData.toLowerCase()
    const indexof_SearchText = plainData_lower.indexOf(searchText_lower)
    if (plainData && indexof_SearchText !== -1) {
      if (indexof_SearchText === 0) {
        plainData = plainData.substring(0, 100) + '...'
      } else if (indexof_SearchText > 0 && indexof_SearchText < 100) {
        const substring_before_search = plainData.substring(0, indexof_SearchText)
        const substring_after_search = plainData.substring(indexof_SearchText + searchText_lower.length, 100)
        plainData = `${substring_before_search}${words[0]}${substring_after_search}...`
      } else if (indexof_SearchText > 100) {
        const substring_before_search = plainData.substring(indexof_SearchText - 20, indexof_SearchText)
        const substring_after_search = plainData.substring(indexof_SearchText + searchText_lower.length, indexof_SearchText + searchText_lower.length + 100)
        plainData = `...${substring_before_search}${words[0]}${substring_after_search}...`
      }

      let tmp_plainData = plainData
      words.forEach((word) => {
        if (word && word.length > 1) {
          const wordRegex = new RegExp(word, 'gi')
          if (wordRegex.test(tmp_plainData.replace(/<[^>]*>/g, ''))) {
            const wordWithCase = tmp_plainData.match(wordRegex)
            tmp_plainData = tmp_plainData.replace(wordRegex, `<span class="font-weight-700">${wordWithCase[0]}</span>`)
          }
        }
      })
      set_content(tmp_plainData)
    } else {
      set_content(plainData.substring(0, 100) + '...')
    }
  }, [content.plain_content, content.title, searchText])

  const handleClick = (e, content) => {
    e.preventDefault()
    if (content.is_accessible) {
      if (content.type === 'page' && content.is_draft) {
        history.push(`/pages/drafts/edit/${generateSlug(content)}`)
      } else if (content.type === 'page' && !content.is_draft) {
        history.push(`/page/${generateSlug(content)}`)
      } else if (content.type === 'response') {
        history.push(`/response/${generateSlug(content)}`)
      }
      props.toggleGlobalSearchModal(false)
    }
  }
  return (
    <li className={`${!content.is_accessible ? 'disabled' : ''}`}>
      {content.type === 'page' && content.is_draft && (
        <>
          <DraftPageIcon />
          <a href={`/pages/drafts/edit/${generateSlug(content)}`} className='content-info' onClick={(e) => handleClick(e, content)}>
            <div className='title' dangerouslySetInnerHTML={{ __html: _title }}></div>
            <div className='category-info'> Draft &bull; {content.category?.name || 'Private'}</div>
            {_content && <div className='content' dangerouslySetInnerHTML={{ __html: _content }}></div>}
          </a>
        </>
      )}
      {content.type === 'page' && !content.is_draft && (
        <>
          <PageIcon />
          <a href={`/page/${generateSlug(content)}`} className='content-info' onClick={(e) => handleClick(e, content)}>
            <div className='title' dangerouslySetInnerHTML={{ __html: _title }}></div>
            <div className='category-info'>Page &bull; {content.category?.name || 'Private'}</div>
            {_content && <div className='content' dangerouslySetInnerHTML={{ __html: _content }}></div>}
          </a>
        </>
      )}
      {content.type === 'response' && (
        <>
          <ResponseIcon />
          <a href={`/response/${generateSlug(content)}`} className='content-info' onClick={(e) => handleClick(e, content)}>
            <div className='title'>
              <span dangerouslySetInnerHTML={{ __html: _title }}></span>
              {content.shortcut && <ShortcutBadge dir={direction(content.shortcut)} className='ml-auto'>{content.shortcut}</ShortcutBadge>}
            </div>
            <div className='category-info'>Response &bull; {content.category?.name || 'Private'}</div>
            {_content && <div className='content' dangerouslySetInnerHTML={{ __html: _content }}></div>}
          </a>
        </>
      )}
      {!content.is_accessible && <UpgradeButton />}
    </li>
  )
}

export default SearchItem
